// Copyright (c) 2020 Deere & Company

import t from 'tcomb';

const ClaimRules = t.struct({
    showPartInvoiceNumber: t.Boolean
}, {
    name: 'ClaimRules',
    strict: true
});

export const getDefaultState = () => new ClaimRules({
    showPartInvoiceNumber: false
});

export default ClaimRules;



// WEBPACK FOOTER //
// ./~/@deere/cps-it.warranty-model-factory/lib/claim-rules.js